import { Component, Input, Output, EventEmitter, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DisplayDetails } from '@olv/ui-shared/models/display-details.interface';
import { FormatCoinCurrencyPipe } from '@olv/ui-shared/pipes/format-coin-currency.pipe';
import { ButtonComponent } from '@olv/ui-shared/ui-shared/button/button.component';
import { NetworkMetadataService } from '@olv/ui-shared/services/network-metadata.service';
import { symbolIcon, useFallbackIcon } from '@olv/ui-shared/utils/asset-balance.utils';

@Component({
  selector: 'app-success-view',
  standalone: true,
  imports: [CommonModule, MatTooltipModule, FormatCoinCurrencyPipe, ButtonComponent],
  templateUrl: './success-view.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./success-view.component.scss'],
})
export class SuccessViewComponent {
  protected readonly useFallbackIcon = useFallbackIcon;
  @Input() displayDetails: DisplayDetails = {
    currency: '',
    sourceWallet: '',
    sourceWalletName: '',
    amount: 0,
    targetWallet: '',
    targetWalletName: '',
    exchangeRate: 0,
    convertedAmount: 0,
    baseCurrencySymbol: '',
    baseCurrencyPrecision: 0,
    currencyPrecision: 0,
  };

  @Input() title = 'Sent Successfully';
  @Input() actionButtonText = 'New Withdraw';
  @Input() showTransactionId = false;
  @Input() transactionId: string | null = null;
  @Input() error: string | null = null;
  @Input() isSettlementApp = true;
  @Output() actionClicked = new EventEmitter<void>();
  @Output() closeClicked = new EventEmitter<void>();

  private readonly metadata = inject(NetworkMetadataService);

  constructor() {
    this.metadata.load();
  }

  getCurrencyIconPath(currency: string): string {
    return symbolIcon(currency, this.metadata);
  }

  getShortAddress(address: string, front = 8, back = 8): string {
    if (!address || address.length <= front + back) {
      return address;
    }
    const start = address.slice(0, front);
    const end = address.slice(-back);
    return `${start}...${end}`;
  }

  onActionClick(): void {
    this.actionClicked.emit();
  }

  onCloseClick(): void {
    this.closeClicked.emit();
  }
}
